(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["talon-bundle-checkout"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('talon-bundle-checkout')) {
  class TalonBundleCheckout extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';
      if (this.classList.contains('tb--home')) {
        this.visualLayout = window.matchMedia('(max-width: 699px)');
        this.placeVisual = () => {
          const visual = this.querySelector('.tb__visual');
          const purchase = this.querySelector('.tb__purchase');
          if (this.visualLayout.matches) purchase.insertBefore(visual, purchase.querySelector('.tb__summary'));
          else this.querySelector('.tb__inner').append(visual);
        };
        this.visualLayout.addEventListener('change', this.placeVisual);
        this.placeVisual();
      }
      this.radios = [...this.querySelectorAll('.tb__radio')];
      const params = new URLSearchParams(location.search);
      const count = params.get('bottles');
      const requested = this.radios.find(radio => radio.value === count && !radio.disabled);
      if (requested) requested.checked = true;
      let initial = this.radios.find(radio => radio.checked && !radio.disabled);
      if (!initial) initial = this.radios.find(radio => !radio.disabled);
      if (initial) { initial.checked = true; this.select(initial, false); }
      else this.querySelectorAll('[data-checkout-link]').forEach(button => { button.disabled = true; });
      this.addEventListener('change', event => {
        if (event.target.matches('.tb__radio')) this.select(event.target, true);
        if (event.target.matches('[data-bundle-quantity]')) {
          const selected = this.radios.find(radio => radio.checked && !radio.disabled);
          if (selected) this.select(selected, false);
        }
      });
      this.querySelector('#TalonCheckoutForm-' + this.id.replace('TalonBundles-', '')).addEventListener('submit', event => {
        if (this.dataset.checkoutBusy === 'true') {
          event.preventDefault();
          return;
        }
        this.dataset.checkoutBusy = 'true';
        this.querySelectorAll('[data-checkout-link]').forEach(button => {
          button.disabled = true;
          button.setAttribute('aria-busy', 'true');
        });
      });
      this.addEventListener('click', event => {
        const button = event.target.closest('.tb__gallery-button');
        if (!button || !this.contains(button)) return;
        const image = this.querySelector('.tb__hero-image');
        image.removeAttribute('srcset');
        image.src = button.dataset.galleryImage;
        image.alt = button.dataset.galleryAlt;
        this.dataset.galleryDetail = String(!button.hasAttribute('data-gallery-package'));
        this.querySelectorAll('.tb__gallery-button').forEach(item => item.setAttribute('aria-pressed',String(item === button)));
      });
      const photo = this.querySelector('.tb__photo');
      photo.addEventListener('pointerdown', event => { if (!this.classList.contains('tb--home')) this.galleryPointer = {x:event.clientX,y:event.clientY}; });
      photo.addEventListener('pointerup', event => {
        if (!this.galleryPointer) return;
        const dx = event.clientX - this.galleryPointer.x;
        const dy = event.clientY - this.galleryPointer.y;
        this.galleryPointer = null;
        if (Math.abs(dx) < 45 || Math.abs(dx) <= Math.abs(dy)) return;
        const buttons = [...this.querySelectorAll('.tb__gallery-button')];
        const current = buttons.findIndex(button => button.getAttribute('aria-pressed') === 'true');
        buttons[(Math.max(0,current) + (dx < 0 ? 1 : -1) + buttons.length) % buttons.length].click();
      });
      this.querySelector('.tb__gallery').addEventListener('keydown', event => {
        if (!['ArrowLeft','ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        const buttons = [...this.querySelectorAll('.tb__gallery-button')];
        const current = buttons.indexOf(event.target);
        const next = buttons[(Math.max(0,current)+(event.key === 'ArrowRight' ? 1 : -1)+buttons.length)%buttons.length];
        next.click(); next.focus();
      });
      this.onPageShow = event => {
        if (event.persisted && this.dataset.checkoutBusy === 'true') window.location.reload();
      };
      window.addEventListener('pageshow', this.onPageShow);
      this.onScroll = () => {
        const primary = this.querySelector('.tb__purchase > [data-checkout-link]');
        const bounds = primary.getBoundingClientRect();
        const footer = this.classList.contains('tb--home') ? document.getElementById('section-footer') : null;
        const footerVisible = footer && footer.getBoundingClientRect().top < window.innerHeight;
        this.dataset.sticky = String(bounds.bottom <= 0 && !footerVisible);
      };
      window.addEventListener('scroll', this.onScroll, {passive:true});
      window.addEventListener('resize', this.onScroll, {passive:true});
      this.onScroll();
    }
    select(radio, updateUrl) {
      if (radio.disabled) return;
      const data = radio.dataset;
      const quantity = Number(this.querySelector('[data-bundle-quantity]').value);
      this.dataset.multiplePacks = String(quantity > 1);
      const total = quantity === 1 ? data.total : new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency:this.dataset.currency}).format(Number(data.price) * quantity / 100);
      const name = quantity === 1 ? data.name : `${quantity} × ${data.name}`;
      this.querySelector('[data-checkout-variant]').value = data.variant;
      this.querySelectorAll('.tb__gallery-button').forEach(button => button.setAttribute('aria-pressed','false'));
      const image = this.querySelector('.tb__hero-image');
      image.removeAttribute('srcset');
      image.src = data.image;
      image.alt = data.imageAlt;
      this.dataset.galleryDetail = 'false';
      const packageButton = this.querySelector('[data-gallery-package]');
      if (packageButton) {
        packageButton.dataset.galleryImage = data.image;
        packageButton.dataset.galleryAlt = data.imageAlt;
        packageButton.setAttribute('aria-pressed','true');
        packageButton.querySelector('img').src = data.image;
        packageButton.querySelector('img').removeAttribute('srcset');
      }
      this.querySelector('[data-visual-package]').textContent = [data.capsules,data.supply].join(' · ');
      this.querySelector('[data-selected-name]').textContent = name;
      this.querySelector('[data-selected-details]').textContent = `${data.supply} · ${data.capsules}`;
      this.querySelector('[data-selected-total]').textContent = total;
      this.querySelector('[data-mobile-name]').textContent = name;
      this.querySelector('[data-mobile-price]').textContent = total;
      this.querySelector('[data-details-link]').href = data.url;
      this.querySelectorAll('[data-checkout-link]').forEach(link => {
        link.disabled = false;
        link.removeAttribute('aria-disabled');
        link.removeAttribute('tabindex');
      });
      if (updateUrl) {
        const url = new URL(location.href);
        url.searchParams.set('bottles',radio.value);
        history.replaceState(null,'',url);
      }
      this.dispatchEvent(new CustomEvent('talon:package-change', {bubbles:true,detail:{bottles:Number(radio.value),variantId:data.variant}}));
    }
    disconnectedCallback() {
      if (this.visualLayout && this.placeVisual) this.visualLayout.removeEventListener('change', this.placeVisual);
      window.removeEventListener('pageshow', this.onPageShow);
      window.removeEventListener('scroll',this.onScroll);
      window.removeEventListener('resize',this.onScroll);
    }
  }
  customElements.define('talon-bundle-checkout',TalonBundleCheckout);
}

if (!customElements.get('talon-offer-countdown')) {
  customElements.define('talon-offer-countdown', class extends HTMLElement {
    connectedCallback() {
      clearInterval(this.timer);
      const end = Date.parse(this.dataset.end);
      const time = this.querySelector('time');
      if (Number.isFinite(end)) time.textContent = new Intl.DateTimeFormat(document.documentElement.lang || 'en-GB', {day:'numeric',month:'short',hour:'2-digit',minute:'2-digit',hourCycle:'h23',timeZone:'Europe/London',timeZoneName:'short'}).format(end);
      this.tick = () => {
        const remaining = Math.floor((end - Date.now()) / 1000);
        if (!Number.isFinite(remaining) || remaining <= 0) {
          this.hidden = true;
          clearInterval(this.timer);
          return;
        }
        const values = {days:Math.floor(remaining / 86400),hours:Math.floor(remaining / 3600) % 24,minutes:Math.floor(remaining / 60) % 60,seconds:remaining % 60};
        for (const [name,value] of Object.entries(values)) {
          const node = this.querySelector('[data-' + name + ']');
          const text = String(value).padStart(2,'0');
          if (node.textContent !== text) node.textContent = text;
        }
        this.querySelector('.tb__offer-clock').hidden = false;
      };
      this.tick();
      if (!this.hidden) this.timer = setInterval(this.tick,1000);
    }
    disconnectedCallback() { clearInterval(this.timer); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["talon-customer-experiences"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){
  const link=event.target.closest('[data-talon-open-reviews]');
  if(!link)return;
  const opener=document.querySelector('[aria-label="Click to open Judge.me floating reviews tab"]');
  if(opener){event.preventDefault();opener.click();}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["talon-formula"] && !Shopify.designMode) return;
  try {
    

(()=>{
  const frameTops=[254,253,254,253,254,253,254,253,253,256,253,256,253,256,253,256,253,254,253,254,253,254,253,254,253,254,253,255,253,255,253,0,0,0,0,0,0,0,26,204,254,253,253,0,92,201,192,187,184,196,202,199,202,210,218,218,218,218,218,218,218,218,218,218,218,218,218,218,218,218,218,218,218,218,218,218,218,218,218,218,218,218,218,218,218,218,218,218,218,218,218,218,218];
  function init(root){
    if(root.dataset.ready)return;
    root.dataset.ready='true';
    const canvas=root.querySelector('canvas'),ctx=canvas.getContext('2d'),range=root.querySelector('input'),img=new Image();
    const mobile=matchMedia('(max-width:749px)'),reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;
    let ready=false,touched=false,scheduled=false;
    function draw(n){
      if(!ready)return;
      n=Math.max(0,Math.min(92,Math.round(n)));
      const height=mobile.matches?760:1080;
      if(canvas.height!==height)canvas.height=height;
      ctx.clearRect(0,0,610,height);
      if(mobile.matches){
        const top=frameTops[n],sourceHeight=640-top,scale=Math.min(610/360,height/sourceHeight);
        const width=360*scale,drawHeight=sourceHeight*scale;
        ctx.drawImage(img,(n%8)*360,Math.floor(n/8)*640+top,360,sourceHeight,(610-width)/2,height-drawHeight,width,drawHeight);
      }else{
        ctx.drawImage(img,(n%8)*360,Math.floor(n/8)*640,360,640,0,0,610,1080);
      }
      range.value=n;
    }
    img.onload=()=>{ready=true;draw(65)};
    const observer=new IntersectionObserver(entries=>{
      if(entries.some(e=>e.isIntersecting)){
        img.src='https://cdn.shopify.com/s/files/1/0671/2914/7592/files/talon-rotation-fixed.webp?v=1792188311';
        observer.disconnect();
      }
    },{rootMargin:'600px'});
    observer.observe(root);
    range.addEventListener('input',()=>{touched=true;draw(Number(range.value))});
    mobile.addEventListener('change',()=>draw(Number(range.value)));
    function scroll(){
      if(touched||reduced||scheduled)return;
      scheduled=true;
      requestAnimationFrame(()=>{
        scheduled=false;
        const r=root.querySelector('.tf-dark').getBoundingClientRect();
        const progress=Math.max(0,Math.min(1,(innerHeight*.8-r.top)/(innerHeight*.7)));
        draw(progress*92);
      });
    }
    addEventListener('scroll',scroll,{passive:true});
  }
  document.querySelectorAll('[data-talon-formula]').forEach(init);
  document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-talon-formula]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["talon-month-offer"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('talon-month-offer')){
    customElements.define('talon-month-offer',class extends HTMLElement{
      connectedCallback(){
        this.end=Date.parse(this.dataset.end);
        if(Number.isFinite(this.end))this.querySelector('time').textContent=new Intl.DateTimeFormat(document.documentElement.lang||'en-GB',{day:'numeric',month:'short',year:'numeric',hour:'2-digit',minute:'2-digit',hourCycle:'h23',timeZone:'Europe/London',timeZoneName:'short'}).format(this.end);
        this.tick=()=>{
          const remaining=Math.max(0,Math.floor((this.end-Date.now())/1000));
          if(!Number.isFinite(remaining)||remaining<=0){
            this.hidden=true;
            this.setAttribute('aria-label',this.dataset.expired);
            clearInterval(this.timer);
            return;
          }
          const values={days:Math.floor(remaining/86400),hours:Math.floor(remaining/3600)%24,minutes:Math.floor(remaining/60)%60};
          for(const [name,value] of Object.entries(values))this.querySelector('[data-'+name+']').textContent=String(value).padStart(2,'0');
          this.querySelector('.tmo__clock').hidden=false;
        };
        this.tick();
        if(!this.hidden)this.timer=setInterval(this.tick,1000);
      }
      disconnectedCallback(){clearInterval(this.timer)}
    });
  }

  } catch(e) { console.error(e); }
})();
})();
